import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

import {
  getToneClasses,
  type SemanticTone,
  type ToneIntensity,
} from "./tone-styles"

export type StatusAlertTone = "success" | "danger" | "warning" | "info"

const toneMap: Record<StatusAlertTone, SemanticTone> = {
  success: "success",
  danger: "danger",
  warning: "warning",
  info: "info",
}

export function StatusAlert({
  tone,
  intensity,
  children,
  className,
}: {
  tone: StatusAlertTone
  intensity?: ToneIntensity
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "rounded-xl border p-3 text-sm",
        getToneClasses(toneMap[tone], intensity),
        className,
      )}
      role={tone === "danger" || tone === "warning" ? "alert" : "status"}
      aria-live={
        tone === "danger" || tone === "warning" ? "assertive" : "polite"
      }
      aria-atomic="true"
    >
      {children}
    </div>
  )
}
